/**
 * La cita tal como la ve el paciente, y el criterio de "próxima".
 *
 * Vive fuera de las pantallas porque lo comparten dos: "Mis citas" la lista
 * completa y "Pagos" muestra las próximas con su valor. Las dos usan además la
 * misma llave de consulta (`patient-appointments`), así que TanStack entrega
 * los mismos datos sin una segunda ida al servidor.
 */

export interface PortalAppointment {
  id: string
  startsAt: string
  endsAt: string
  status: string
  modality: string
  cancellationReason?: string | null
  videoCallUrl?: string | null
  visitAddress?: string | null
  service: { name: string; durationMin: number; basePrice: number }
  /** Política de abono de la prestación, calculada en el backend (decisión #6). */
  deposit: { required: boolean; amount: number }
  professional: { firstName: string; lastName: string; specialty?: string | null }
  location: { name: string; address?: string | null }
}

/**
 * Citas futuras vigentes, de la más próxima a la más lejana. La lista llega
 * ordenada al revés (la más reciente primero, que es lo correcto para el
 * historial), de ahí el `reverse`.
 */
export function upcomingFirst(all: PortalAppointment[], now = new Date().toISOString()): PortalAppointment[] {
  return all.filter((a) => a.startsAt >= now && !['CANCELLED', 'NO_SHOW'].includes(a.status)).reverse()
}
